import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=74055d7c&scoped=true&"
import script from "./DocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=74055d7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74055d7c",
  null
  
)

export default component.exports